import styled from '../../utils/styled';
import { mediaBreakpointDownMD } from '../../../constants/style-constants';

const getBackgroundColor = (open, alternate) => {
  if (alternate) return 'transparent';

  return open ? '#101010' : '#0f0f0f';
};

const getBorderBottom = (open, alternate) => {
  if (alternate) return 'none';

  return open ? 'none' : '1px solid #4ec3f7';
};

const getBackgroundColorMobile = (open, alternate) => {
  if (alternate) return 'transparent';

  return open ? '#101010' : '#000';
};

const getBorderBottomMobile = (open, alternate) => {
  if (alternate) return 'none';

  return open ? 'none' : '1px solid #343434';
};

export const ButtonContainer = styled.button(({ open, alternate }) => ({
  width: '136px',

  border: 'none',
  color: alternate ? '#002266' : '#fff',
  padding: '7px',
  paddingBottom: '30px',
  marginBottom: open ? '-10px' : '0',
  backgroundColor: getBackgroundColor(open, alternate),
  cursor: 'pointer',
  fontFamily: '"Spyscapetwo webfont", sans-serif',
  lineHeight: '2.17',
  fontSize: '12px',
  fontWeight: '300',
  textTransform: 'uppercase',
  alignItems: 'baseline',
  justifyContent: 'center',
  position: 'absolute',
  display: 'flex',
  borderBottom: getBorderBottom(open, alternate),
  height: open ? '50px' : '40px',
  transition: 'background-color 0.3s linear',
  outline: 'none',
  left: '20px',

  '&:hover': {
    backgroundColor: alternate ? 'transparent' : '#383838',
    color: alternate ? '#4ecef7' : '#fff',
  },

  [mediaBreakpointDownMD]: {
    left: '0',
    padding: '0',
    alignItems: 'center',
    display: 'flex',
    width: '60px',
    height: '60px',
    margin: '0px',
    borderBottom: getBorderBottomMobile(open, alternate),
    borderRight: alternate ? 'none' : '1px solid #343434',
    borderLeft: 'none',
    backgroundColor: getBackgroundColorMobile(open, alternate),
  },

  '> img': {
    transition: 'transform 0.3s linear',
    transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
  },
}));

export const ButtonText = styled.div({
  display: 'block',
  paddingRight: '10px',
  fontFamily: "'Spyscapetwo webfont',sans-serif",
  [mediaBreakpointDownMD]: {
    display: 'none',
  },
});

export const ButtonIcon = styled.img({
  display: 'block',
  [mediaBreakpointDownMD]: {
    paddingLeft: '0px',
  },
});
